import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from 'src/app/services/lookup-data.service';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { AttorneyProfileService } from 'src/app/services/attorney-profile.service';
import { USER_PERMISSIONS } from 'permission-library';
import { take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-perm-task',
  templateUrl: './perm-task.component.html',
  styleUrls: ['./perm-task.component.scss']
})
export class PermTaskComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  @Input() reSuperTask:any;
  permTaskForm: FormGroup;
  serviceCenters: any[] = [];
  reviewUsersList: any[] = [];
  attorneys: any[] = [];
  attorneyUsers: any[] = [];
  users: any[] = [];
  selectedSignatory: any;
  selectedDesignation: any;
  selectedPreparer: any;
  selectedPetitionPreparer: any;
  isAttorneySelect: boolean;
  userType: string;
  primaryCompanyId: number;
  employeeDetails: any;
  @Input() subTaskDetails: any;

  constructor(private fb: FormBuilder, private lookupService: LookupService, private attorneyProfileService: AttorneyProfileService) {
    this.permTaskForm = this.fb.group({
      authorizedSignatoryId: ['', Validators.required],
      // processingType:  ['', Validators.required],
      // serviceCenterId:  [0, Validators.required],
      attorneyId: [''],
      immSpecialistId: [null],
      preparerAttorneyId: [0],
      immigrantTypeCode: [''],
      isAttorneySame: [0],
      isCaseTransferred: [0],
      selectedDesignation: [''],
    });


  }

  ngOnInit(): void {
    if (this.permTaskForm) {
      for (const [key, value] of Object.entries(this.permTaskForm.controls)) {
        this.parentFormGroup.addControl(key, value);
      }
    }

    this.userType = sessionStorage.getItem('userTypeRole');
    this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
    let isOnlySignatory = true; // to load the signatory users

    combineLatest([
      this.lookupService.getReviewersUser(this.parentFormGroup.get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER, isOnlySignatory),
      this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId')),
      this.lookupService.getUsersOfCompany(this.parentFormGroup.get('companyId').value)
    ])
      .pipe(take(1))
      .subscribe(data => {
        this.reviewUsersList = data[0];
        this.attorneys = data[1];
        this.users = data[2];
        if(this.reSuperTask && this.reviewUsersList && this.reviewUsersList.length > 0){
          this.userSelected(this.reSuperTask.signatoryId)
        }
        if(this.reSuperTask && this.attorneys && this.attorneys.length > 0){
          this.attorneySelected(this.reSuperTask.attorneyId)
        }
        if(this.reSuperTask && this.attorneys && this.users.length > 0){
          this.onPetitionerPreparerSelected(this.reSuperTask.immSpecialistId)
        }
        if(this.subTaskDetails){
          this.permTaskForm.patchValue({
            signatoryId: this.subTaskDetails?.signatoryId,
            attorneyId: this.subTaskDetails?.attorneyId,
            immSpecialistId: this.subTaskDetails?.immSpecialistId,
            preparerAttorneyId: this.subTaskDetails?.preparerAttorneyId
          });
          this.attorneySelected(this.subTaskDetails?.attorneyId);
          this.userSelected(this.subTaskDetails?.signatoryId);
          this.onPetitionerPreparerSelected(this.subTaskDetails?.immSpecialistId);
        }
        if (this.userType === 'Attorney') {
          this.attorneyProfileService.getEmployeeDetails(this.primaryCompanyId, parseInt(sessionStorage.getItem('employeeId')))
            .subscribe(employeeDetailsData => {
              this.employeeDetails = employeeDetailsData;
              sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
              this.permTaskForm.patchValue({
                attorneyId: employeeDetailsData['companyId'],
                preparerAttorneyId: employeeDetailsData['id']
              });
            });
          this.isAttorneySelect = false;
        }else {
          
          this.isAttorneySelect = true;
        }
      });
  }

  // onChangeProcessingType() {
  //   this.serviceCenters = [];
  //   this.getServiceCenter();
  // }

  // getServiceCenter() {
  //   let processingType = this.permTaskForm.get('processingType').value;
  //   let visaType = this.parentFormGroup.get('visaType').value;
  //   let petitionType = this.parentFormGroup.get('petitionType').value;
  //   this.lookupService.getServiceCenters(!(processingType == 'regular'), visaType, petitionType)
  //     .subscribe((data: Array<any>) => {
  //       this.serviceCenters = data;
  //     });
  // }

  userSelected(authorizedSignatoryId?) {
    const id = authorizedSignatoryId ? authorizedSignatoryId : this.permTaskForm.get('authorizedSignatoryId').value;
    this.selectedSignatory = this.reviewUsersList.find(ele => ele.id == id);
    this.permTaskForm.patchValue({
      selectedDesignation: this.selectedSignatory.designation,
      authorizedSignatoryId:id

    });
    this.selectedDesignation = this.selectedSignatory.designation;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  attorneySelected(attorneyIdVal?) {
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    const attorneyId = attorneyIdVal ? attorneyIdVal :this.permTaskForm.get('attorneyId').value;
    if (attorneyId && attorneyId !== '') {
      this.lookupService.getUsersOfCompany(attorneyId).subscribe((data: Array<any>) => {
        this.attorneyUsers = data;
        if(attorneyIdVal && this.attorneyUsers && this.attorneyUsers.length > 0){
          this.permTaskForm.patchValue({
            attorneyId: attorneyId,
          });
          if(this.reSuperTask && this.reSuperTask?.preparerAttorneyId){
            this.userPreparerSelected(this.reSuperTask.preparerAttorneyId)
          }else if(this.subTaskDetails?.preparerAttorneyId){
            this.userPreparerSelected(this.subTaskDetails.preparerAttorneyId);
          }
        }
      });
     
      
    }
    else {
      this.attorneyUsers = [];
    }
  }

  userPreparerSelected(preparerAttorneyId?) {
    const id = preparerAttorneyId ? preparerAttorneyId : this.permTaskForm.get('preparerAttorneyId').value;
    if(preparerAttorneyId){
      this.permTaskForm.patchValue({
        preparerAttorneyId: preparerAttorneyId,
      });
    }
    this.selectedPreparer = this.attorneyUsers.find(ele => ele.id == id);
    sessionStorage.setItem("setPreparerAttorneyId", this.selectedPreparer['id']);
  }

  onPetitionerPreparerSelected(immSpecialistId?) {
    const id = immSpecialistId? immSpecialistId: this.permTaskForm.get('immSpecialistId').value;
    if(immSpecialistId){
      this.permTaskForm.patchValue({
        immSpecialistId: immSpecialistId,
      });
    }
    this.selectedPetitionPreparer = this.users.find(ele => ele.id == id);
  }



  ngOnDestroy() {
    // removing sub form controls from the parent form
    if (this.permTaskForm) {
      for (const [key, value] of Object.entries(this.permTaskForm.controls)) {
        this.parentFormGroup.removeControl(key);
      }
    }
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
  }

}
